"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Header = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@mui/material/styles");
var _AppBar = _interopRequireDefault(require("@mui/material/AppBar"));
var _Toolbar = _interopRequireDefault(require("@mui/material/Toolbar"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _MenuItem = _interopRequireDefault(require("@mui/material/MenuItem"));
var _Menu = _interopRequireDefault(require("@mui/material/Menu"));
var _IconButton = _interopRequireDefault(require("@mui/material/IconButton"));
var _Language = _interopRequireDefault(require("@mui/icons-material/Language"));
var _BookmarkAdd = _interopRequireDefault(require("@mui/icons-material/BookmarkAdd"));
var _BookmarkRemove = _interopRequireDefault(require("@mui/icons-material/BookmarkRemove"));
var _Bookmarks = _interopRequireDefault(require("@mui/icons-material/Bookmarks"));
var _Switch = _interopRequireDefault(require("@mui/material/Switch"));
var _Share = _interopRequireDefault(require("@mui/icons-material/Share"));
var _reactI18next = require("react-i18next");
var Header = function Header(_ref) {
  var title = _ref.title,
    market = _ref.market,
    variety = _ref.variety,
    prices = _ref.prices,
    languages = _ref.languages,
    bookmarks = _ref.bookmarks,
    onBookmarkEdit = _ref.onBookmarkEdit,
    onBookmarkClick = _ref.onBookmarkClick,
    onThemeToggle = _ref.onThemeToggle,
    onShare = _ref.onShare,
    _ref$isHome = _ref.isHome,
    isHome = _ref$isHome === void 0 ? false : _ref$isHome;
  var theme = (0, _styles.useTheme)();
  var _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    bmAnchor = _useState2[0],
    setBmAnchor = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    langAnchor = _useState4[0],
    setLangAnchor = _useState4[1];
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t,
    i18n = _useTranslation.i18n;
  var isBookmarked = bookmarks.find(function (bm) {
    return bm.market === market && bm.variety === variety;
  });
  var changeLanguage = function changeLanguage(l) {
    i18n.changeLanguage(l);
    setLangAnchor(null);
  };
  var renderBookmarkIcon = function renderBookmarkIcon(isBookmarked) {
    return isBookmarked ? /*#__PURE__*/_react.default.createElement(_BookmarkRemove.default, {
      role: "image"
    }) : /*#__PURE__*/_react.default.createElement(_BookmarkAdd.default, {
      role: "image"
    });
  };
  return /*#__PURE__*/_react.default.createElement(_AppBar.default, {
    component: "header",
    position: "fixed",
    className: "app-header"
  }, /*#__PURE__*/_react.default.createElement(_Toolbar.default, {
    className: "header",
    disableGutters: true
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "subtitle2",
    sx: {
      color: theme.palette.text.primary
    }
  }, title), /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    className: "app-share",
    onClick: onShare,
    sx: {
      ml: 'auto'
    },
    "aria-label": t('share'),
    "aria-haspopup": "false",
    disabled: !isHome
  }, /*#__PURE__*/_react.default.createElement(_Share.default, {
    role: "image"
  })), /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    className: "app-bookmark-edit",
    "aria-label": isBookmarked ? t('remove from bookmarks') : t('add to bookmarks'),
    "aria-haspopup": "false",
    onClick: onBookmarkEdit,
    disabled: !isHome
  }, renderBookmarkIcon(isBookmarked)), /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    className: "app-bookmark-browse",
    "aria-label": t("browse bookmarks"),
    "aria-controls": "bookmark-menu",
    "aria-haspopup": "true",
    onClick: function onClick(event) {
      return bookmarks.length > 0 ? setBmAnchor(event.currentTarget) : null;
    }
  }, /*#__PURE__*/_react.default.createElement(_Bookmarks.default, {
    role: "image"
  })), /*#__PURE__*/_react.default.createElement(_Menu.default, {
    id: "bookmarks-menu",
    anchorEl: bmAnchor,
    open: Boolean(bmAnchor),
    onClose: function onClose() {
      return setBmAnchor(null);
    }
  }, bookmarks.map(function (bm) {
    return /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
      key: bm.market,
      selected: bm.market === market && bm.variety === variety,
      onClick: function onClick() {
        onBookmarkClick(bm);
        setBmAnchor(null);
      }
    }, t(bm.market), " , ", t(bm.variety));
  })), /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    className: "app-switch-language",
    "aria-label": t("change language"),
    "aria-controls": "language-menu",
    "aria-haspopup": "true",
    onClick: function onClick(event) {
      return setLangAnchor(event.currentTarget);
    }
  }, /*#__PURE__*/_react.default.createElement(_Language.default, {
    role: "image"
  })), /*#__PURE__*/_react.default.createElement(_Menu.default, {
    id: "language-menu",
    anchorEl: langAnchor,
    open: Boolean(langAnchor),
    onClose: function onClose() {
      return setLangAnchor(null);
    }
  }, languages.map(function (lang) {
    return /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
      key: lang.isoCode,
      selected: lang.isoCode === i18n.language,
      onClick: function onClick() {
        return changeLanguage(lang.isoCode);
      }
    }, lang.name);
  })), /*#__PURE__*/_react.default.createElement(_Switch.default, {
    className: "app-toggle-theme",
    color: "secondary",
    checked: theme.name === 'dark',
    inputProps: {
      'aria-label': t('toggle theme')
    },
    onChange: onThemeToggle
  })));
};
exports.Header = Header;